var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SentimentMarketValue',{attrs:{"zoom_start":"50"}}),_c('SentimentMarketTopN',{attrs:{"zoom_start":"50"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }